import { render, staticRenderFns } from "./InventoryProcess.vue?vue&type=template&id=06f37e7f"
import script from "./InventoryProcess.vue?vue&type=script&lang=js"
export * from "./InventoryProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports